<template lang="html">
  <div >
    <!-- Modal de Configuração  -->
    <div class="modal fade" id="modal-config-imprimir" tabindex="-1" role="dialog" a data-backdrop="static">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title text-left" id="myModalLabel">
              <i class="fa fa-print" aria-hidden="true"></i>
              Configurar Formato do Documento
            </h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-1"></div>
              <div class="col-md-5">
                <label>Título de impressão</label><br>
                <input type="text" class="form-control" v-model="form_title">
                <hr>
               <label class="text-warning">O que você quer nesse Documento?</label>
                <input type="checkbox" class="magic-checkbox"
                      id="topo" v-model="form_show.topo">
                      <label for="topo">Meu Cabeçalho</label>

                <!-- <input type="checkbox" class="magic-checkbox"
                       v-model="form_show.title" id="title">
                       <label for="title">Título</label> -->

                <input type="checkbox" class="magic-checkbox"
                       :disabled="!paciente_imp.id"
                        v-model="form_show.paciente" id="paciente">
                      <label for="paciente">Todos os dados do {{ termo_paciente.sing }}</label>

                <input type="checkbox" class="magic-checkbox"
                      :disabled="!paciente_imp.responsavel"
                      v-model="form_show.responsavel" id="resp">
                    <label for="resp">Todos os dados do Responsável</label>

                <input type="checkbox" class="magic-checkbox"
                      :disabled="!paciente_imp.escola"
                      v-model="form_show.escola" id="esc">
                      <label for="esc">Todos os dados da Escola</label>

                <input type="checkbox" class="magic-checkbox"
                        v-model="form_show.rodape_assinatura_user" id="rodape">
                      <label for="rodape">Minha Assinatura</label>

                <input type="checkbox" class="magic-checkbox"
                        :disabled="!paciente_imp.id"
                        v-model="form_show.assinatura_paciente" id="a_paci">
                      <label for="a_paci">Assinatura do {{ termo_paciente.sing }}</label>

                <input type="checkbox" class="magic-checkbox"
                        :disabled="!paciente_imp.responsavel"
                        v-model="form_show.assinatura_reponsavel" id="a_resp">
                      <label for="a_resp">Assinatura do Responsável</label>

                <input type="checkbox" class="magic-checkbox"
                        :disabled="!paciente_imp.escola"
                        v-model="form_show.assinatura_escola" id="a_escola">
                      <label for="a_escola">Assinatura da Escola</label>

                <input type="checkbox" class="magic-checkbox"
                        v-model="form_show.outras_assinaturas" id="outra">
                      <label for="outra">Outras Assinaturas</label>

                <!-- <hr> -->
                <!-- <img src="/img/page/config-imp.png" alt="Configurar Impressão"> -->
              <!-- {{show}} -->
            </div>
                  <div class="col-md-5">
                    <div class="panel panel-primary">
                      <div class="panel-heading">
                        <h3 class="panel-title">
                          <span class="text-primary">Formato</span>
                        </h3>
                      </div>
                      <div class="panel-body">
                                <div class="panel panel-default" v-show="form_show.topo">
                                    <div class="panel-body">
                                      <small > Meu <b>Cabeçalho</b> pré-configurado.</small>
                                    </div>
                                </div>
                                <div class="text-center" >
                                    <small>
                                      {{ form_title }}
                                    </small>
                                </div>
                                <div class="panel panel-default"
                                    v-show="form_show.paciente || form_show.responsavel || form_show.escola">
                                    <div class="panel-body">
                                      <small v-show="form_show.paciente">Todos os dados do <b>{{ termo_paciente.sing }}</b> <br></small>
                                      <small v-show="form_show.responsavel">Todos os dados do <b>Responsável</b><br></small>
                                      <small v-show="form_show.escola">Todos os dados da <b>Escola</b></small>
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-body">
                                      <small> <b>Conteúdo</b> do Documento</small>
                                    </div>
                                </div>
                                <center>
                                    <small v-show="form_show.rodape_assinatura_user">
                                      __________________<br>
                                      Minha <b>Assinatura</b><br>
                                    </small>
                                    <small v-show="form_show.assinatura_paciente">
                                      __________________<br>
                                      Assinatura do <b>{{ termo_paciente.sing }}</b><br>
                                    </small>
                                    <small v-show="form_show.assinatura_reponsavel">
                                      __________________<br>
                                      Assinatura do <b>Responsável</b><br>
                                    </small>
                                    <small v-show="form_show.assinatura_escola">
                                      __________________<br>
                                      Assinatura da <b>Escola</b><br>
                                    </small>
                                    <small v-show="form_show.outras_assinaturas">
                                      __________________<br>
                                      Assinatura   <br>
                                      __________________<br>
                                      Assinatura
                                    </small>
                                </center>

                      </div>
                    </div>

                  </div>
                  <div class="col-md-1"></div>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <i class="fa fa-ban" aria-hidden="true"></i>
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" @click="goImprimir">
              <i class="fa fa-print" aria-hidden="true"></i> Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import { mapState, mapActions, mapGetters } from 'vuex'

export default {

  name: 'open-modal-config-imprimir',

  data(){
    return{

        form_title: '',

        form_show : {
            topo: true,
            paciente: true,
            responsavel: false,
            escola: false,
            rodape_assinatura_user: true,
            assinatura_paciente: false,
            assinatura_reponsavel: false,
            assinatura_escola: false,
            outras_assinaturas: false
        }

    }
  },

  watch:{

    title(){
        this.form_title = _.clone(this.title)
    },

    paciente_imp(){

      let paciente_imp = _.clone(this.paciente_imp)

      if (!paciente_imp.id) {
          this.form_show.paciente = false
          this.form_show.assinatura_paciente = false
      }else {
          this.form_show.paciente = true
      }

      if (!paciente_imp.responsavel) {
        this.form_show.responsavel = false
        this.form_show.assinatura_reponsavel = false
      }

      if (!paciente_imp.escola) {
        this.form_show.escola = false
        this.form_show.assinatura_escola = false
      }

    }

  },

  computed:{

    ...mapState('impressao', [ 'title', 'paciente_imp'] ),

    ...mapGetters('config', ['termo_paciente'])

  },

  methods:{

    ...mapActions('impressao', ['setConfigImprimir']),

    goImprimir(){

        let f_title = _.clone(this.form_title)
        let f_show = _.clone(this.form_show)

        if (!this.paciente_imp.responsavel) {
          f_show.responsavel = false
        }
        if (!this.paciente_imp.escola) {
          f_show.escola = false
        }

        this.setConfigImprimir({ show: f_show, title: f_title })

        $('#modal-config-imprimir').modal('hide')

        this.$router.push('/imprimir')
    }

  }
}

</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/especificos/OpenModalConfigImprimir.vue